// Import DataTables - note that we're importing the vanilla JS version
import DataTable from 'datatables.net-dt';

document.addEventListener('DOMContentLoaded', function() {
    // Check if the table exists on the page
    const tableElement = document.getElementById('safety-table');
    if (tableElement) {
        // Initialize DataTable with vanilla JS
        // Note: DataTables requires a call on the native DOM element
        const safetyTable = new DataTable(tableElement, {
            // Use DataTables' processing option for better user feedback
            processing: true,
            // Disable initial automatic data detection/loading
            deferRender: true,
            // Start with an empty table and manually load data
            data: [],
            responsive: true,
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            pageLength: 25,
            lengthChange: false,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search...",
                emptyTable: "No safety documents found",
                info: "Showing _START_ to _END_ of _TOTAL_ documents",
                infoEmpty: "Showing 0 to 0 of 0 documents",
                infoFiltered: "(filtered from _MAX_ total documents)"
            },
            // Explicitly define columns to avoid parameter warnings
            columns: [
                { 
                    title: "Document Name", 
                    data: "name",
                    defaultContent: "Untitled Document" // Provide default content for null/undefined values
                },
                { 
                    title: "View", 
                    data: "view", 
                    orderable: false,
                    defaultContent: "No link available" // Provide default content for null/undefined values
                }
            ],
            columnDefs: [
                { className: "dt-center", targets: [1] }
            ],
            // Wait for data to be loaded before initializing
            initComplete: function() {
                // Add class to search input using vanilla JS
                const searchInput = document.querySelector('.dataTables_filter input');
                if (searchInput) {
                    searchInput.classList.add('search-input');
                }
                
                // Add custom class to pagination container
                const paginationContainer = document.querySelector('.dataTables_paginate');
                if (paginationContainer) {
                    paginationContainer.classList.add('safety-pagination');
                }
                
                // Add custom class to individual pagination buttons
                const paginationButtons = document.querySelectorAll('.dataTables_paginate .paginate_button');
                paginationButtons.forEach(button => {
                    button.classList.add('safety-page-button');
                });
            }
        });
        
        // Show loading message
        const tableBody = document.querySelector('#safety-table tbody');
        if (tableBody) {
            tableBody.innerHTML = '<tr><td colspan="2">Loading safety documents...</td></tr>';
        }
        
        // Fetch safety manuals posts
        fetchPosts();
        
        async function fetchPosts() {
            if (window.safetyData && window.safetyData.length > 0) {
                populateTable(window.safetyData);
                return;
            }
            try {
                const response = await fetch('/wp-json/wp/v2/safety_manuals?per_page=100');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (data.length > 0) {
                    populateTable(data);
                } else {
                    const tableBody = document.querySelector('#safety-table tbody');
                    if (tableBody) {
                        tableBody.innerHTML = '<tr><td colspan="2">No safety manuals found</td></tr>';
                    }
                }
            } catch (error) {
                const tableBody = document.querySelector('#safety-table tbody');
                if (tableBody) {
                    tableBody.innerHTML = '<tr><td colspan="2">Error loading safety manuals</td></tr>';
                }
            }
        }
        
        function getTermId(slug) {
            return fetch('/wp-json/wp/v2/media_category?slug=' + slug)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data && data.length > 0) {
                        return data[0].id;
                    } else {
                        throw new Error('Term not found');
                    }
                });
        }
        
        function populateTable(files) {
            // Clear existing rows
            safetyTable.clear();
            
            // Create array of data objects that match our column definitions
            const tableData = files.map(function(file) {
                if (!file) return { name: null, view: null }; // Handle null files
                
                // Extract file name without extension for display
                let fileName = '';
                if (file.title && file.title.rendered) {
                    fileName = file.title.rendered;
                }
                
                // Create view button, only if link exists
                let viewBtn = '';
                if (file.link) {
                    viewBtn = '<a href="' + file.link + '" class="download-btn">View Manual</a>';
                }
                
                // Return object with keys matching the 'data' properties in our columns definition
                return {
                    name: fileName || null,  // Use null if empty string to trigger defaultContent
                    view: viewBtn || null  // Use null if empty string to trigger defaultContent
                };
            });
            
            // Add all rows at once
            safetyTable.rows.add(tableData);
            
            // Draw table with new data
            safetyTable.draw();
            
            // If no records found, show a message
            if (files.length === 0) {
                const tableBody = document.querySelector('#safety-table tbody');
                if (tableBody) {
                    tableBody.innerHTML = '<tr><td colspan="2">No safety manuals found</td></tr>';
                }
            }
        }
    }
});
